import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=28ccee50"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports